import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import Modal from './Modal'

const useStyles = makeStyles((theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 1000,
      maxWidth: '90%',
      margin: '0 auto',
    },
  }),
)

interface Props {
  children: (onClick: () => void) => React.ReactNode
  src: string
}

const AudioPlayer: React.FC<Props> = (props) => {
  const { src, children } = props
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      {children(handleOpen)}
      <Modal
        aria-labelledby="audio"
        aria-describedby="audio"
        className={classes.modal}
        open={open}
        onClose={handleClose}
      >
        <>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <audio src={src} autoPlay controls />
        </>
      </Modal>
    </>
  )
}

export default AudioPlayer
